import React, { useState } from 'react'
import { Button, CircularProgress } from '@material-ui/core'
import flowLogo from '../../assets/img/logo-flow.webp'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import moment from 'moment'
import { createSelector } from 'reselect'
import qs from 'qs'

//API
import {
  createReservation,
  updateOrderFlowOrder,
  updateReservationFlowOrder,
  updateInvoiceFlowOrder,
  assignResource,
  getLastReservationDetails,
  getCodeDiscount,
  validationCoupon,
  updateReservationStatus,
} from '../../services/FirebaseServices/reservationServices'

import {
  makeSelectTermsAndConditions,
  set_terms_and_conditions,
} from '../../redux/ducks/verifyReservation'

import {
  makeSelectStartDate,
  makeSelectEndDate,
  makeSelectGuestAmount,
  makeSelectSingleDate,
  makeSelectTime,
  makeSelectChildAmount,
  makeSelectTotalPrice,
  makeSelectHotelHour,
  makeSelectPartialPrice,
  makeSelectService,
  makeSelectSelectedAddons,
  makeSelectAddonsPersonsPrice,
  makeSelectCode,
  makeSelectGiftCard,
  set_code,
  set_total_price,
  makeSelectExitDate,
  makeSelectExitTime,
  makeSelectExtraPersons,
} from '../../redux/ducks/reservationDetails'

import {
  makeSelectName,
  makeSelectLastName,
  makeSelectPhone,
  makeSelectEmail,
  makeSelectGiftedName,
  makeSelectGiftedLastName,
  makeSelectGiftedPhone,
  makeSelectGiftedEmail,
} from '../../redux/ducks/reservationInfo'

import {
  makeSelectSingleExperience,
  makeSelectAgency,
} from '../../redux/ducks/experiences'

import {
  makeSelectTotalOrderPrice,
  makeSelectOrderProducts,
  makeSelectDeliveryAddress,
  makeSelectOrderIndications,
  makeSelectDispatchMethod,
} from '../../redux/ducks/restaurantMenu'

import { createPaymentFlow } from '../../services/PaymentServices'

//HELPERS
import { getDateTime, formatDates, formatDateToDB } from '../../utils/helpers'
import { stateOrder, statePayments, stateReservation } from '../../utils/enums'

import { LazyLoadImage } from 'react-lazy-load-image-component'

const stateSelector = createSelector(
  [
    makeSelectStartDate,
    makeSelectEndDate,
    makeSelectGuestAmount,
    makeSelectName,
    makeSelectLastName,
    makeSelectPhone,
    makeSelectEmail,
    makeSelectTermsAndConditions,
    makeSelectSingleExperience,
    makeSelectSingleDate,
    makeSelectExitDate,
    makeSelectTime,
    makeSelectExitTime,
    makeSelectExtraPersons,
    makeSelectChildAmount,
    makeSelectTotalPrice,
    makeSelectHotelHour,
    makeSelectAgency,
    makeSelectPartialPrice,
    makeSelectTotalOrderPrice,
    makeSelectOrderProducts,
    makeSelectDeliveryAddress,
    makeSelectOrderIndications,
    makeSelectDispatchMethod,
    makeSelectService,
    makeSelectSelectedAddons,
    makeSelectAddonsPersonsPrice,
    makeSelectCode,
    makeSelectGiftedName,
    makeSelectGiftedLastName,
    makeSelectGiftedPhone,
    makeSelectGiftedEmail,
    makeSelectGiftCard,
  ],
  (
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    exitDate,
    time,
    exitTime,
    extraPersons,

    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    service,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  ) => ({
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    exitDate,
    time,
    exitTime,
    extraPersons,

    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    service,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  }),
)

const actionDispatch = (dispatch) => ({
  setTermsAndConditions: (termsAndConditions) =>
    dispatch(set_terms_and_conditions(termsAndConditions)),
  setCode: (code) => dispatch(set_code(code)),
  setTotalPrice: (totalPrice) => dispatch(set_total_price(totalPrice)),
})

const FlowModule = ({
  agencyId,
  experienceId,
  isDiscountApplied,
  detailDiscount,
  isExpirationCode,
  isErrorDay,
  isError,
  validateTerms,
  hotDeal,
  formatDateDif,
}) => {
  const { reservationId, couponId } = useParams()

  const {
    startDate,
    endDate,
    guestAmount,
    name,
    lastName,
    phone,
    email,
    termsAndConditions,
    singleExperience,
    singleDate,
    exitDate,
    time,
    exitTime,
    extraPersons,
    childAmount,
    totalPrice,
    hotelHour,
    agency,
    partialPrice,
    totalOrderPrice,
    orderProducts,
    deliveryAddress,
    orderIndications,
    dispatchMethod,
    selectedAddons,
    addonsPersonsPrice,
    code,
    giftedName,
    giftedLastName,
    giftedPhone,
    giftedEmail,
    giftCard,
  } = useSelector(stateSelector)

  const [isLoadingPayment, setIsLoadingPayment] = useState(false)
  const [detailReservation, setDetailReservation] = useState()
  const [clpToUsd, setClpToUsd] = useState(0)
  const [flowActive, setFlowActive] = useState(false)
  console.log('flowws')
  const handleReservationPayment = async () => {
    /// FETCHRESERVATION
    setFlowActive(true)
    const reservation = await getLastReservationDetails(
      agencyId,
      experienceId,
      reservationId,
    )
    setDetailReservation(reservation)
    console.log('entre', reservation)

    /// FETCHRESERVATION

    setIsLoadingPayment(true)
    const reservationDetails = formatReservationDetails()
    const reservationIDS = await handleReservation()
    console.log(reservationIDS)


    const formData = new FormData()
    if (
      singleExperience.isPartialCharge /* &&
      singleExperience.partialPercentage === 0 &&
      hotDeal */
    ) {
      let total = 0

      if (isDiscountApplied) {
        /* 
          console.log('discount')
        total =
          totalPrice +
          addonsPersonsPrice -
          ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100
        console.log('discount', total)
        
        */
        console.log('discount')
        total = singleExperience.partialPercentage > 0 ?
          (partialPrice + addonsPersonsPrice) * ((100 - detailDiscount.discount) / 100) :
          (totalPrice + addonsPersonsPrice) * ((100 - detailDiscount.discount) / 100)
        console.log('discount', total)
      } else {
        console.log('else')
        total = totalPrice + addonsPersonsPrice
        console.log('else', total)
      }

      formData.set('amount', total)
    } else if (singleExperience.isPartialCharge) {
      console.log('partialCharge')
      const total = partialPrice //+ addonsPersonsPrice
      formData.set('amount', total)
    } else {
      let total = 0
      // if (!!reservationId && !!couponId) {
      //   console.log('!!reservationId && !!couponId')
      //   // console.log(
      //   //   detailReservation.finalPrice,
      //   //   detailReservation.addonsPersonsPrice,
      //   //   detailDiscount.discount,
      //   // )
      //   // console.log(
      //   //   reservation.finalPrice,
      //   //   reservation.addonsPersonsPrice,
      //   //   detailDiscount.discount,
      //   // )

      //   total =
      //     reservation.finalPrice + reservation.addonsPersonsPrice
      //       ? reservation.addonsPersonsPrice
      //       : 0 -
      //         ((reservation.finalPrice + reservation.addonsPersonsPrice
      //           ? reservation.addonsPersonsPrice
      //           : 0) *
      //           detailDiscount.discount) /
      //           100
      //   console.log('!! & !!', total)
      //   
      // } else
      if (isDiscountApplied) {
        console.log('discount')
        total =
          totalPrice +
          addonsPersonsPrice -
          ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100
        console.log('discount', total)
        formData.set('amount', total)
      } else {
        console.log('else')
        total = totalPrice + addonsPersonsPrice
        console.log('else', total)
      }

      formData.set('amount', total)
    }
    console.log(formData)
    formData.set('name_experience', singleExperience.name)
    formData.set('email', email)
    formData.set('reservation_id', reservationIDS)
    formData.set('agency_id', agency.key)
    formData.set('experience_id', singleExperience.key)
    formData.set('apiKey', agency.apiKey)
    formData.set('secretKey', agency.secretKey)
    debugger;
    createPaymentFlow(formData)
      .then(async (res) => {
        console.log(formData)
        setIsLoadingPayment(false)
        //hacer update a la reserva
        const flowOrder = qs.parse(res.data.split('?')[1]).flowOrder
        if (flowOrder) {
          await updateReservationFlowOrder(
            agency.key,
            singleExperience.key,
            reservationIDS,
            flowOrder,
          )

          console.log(window.open(res.data, '_self'))
          window.open(res.data, '_blank')
        }
      })
      .catch((err) => console.log(err))


  }
  function convertDateFormat(dateString) {
    const parts = dateString.split('/')
    if (parts.length === 3) {
      const day = parts[0].padStart(2, '0')
      const month = parts[1].padStart(2, '0')
      const year = parts[2]
      return `${year}-${month}-${day}`
    }
  }

  const formatReservationDetails = (orderId = '', transaction_ID = '') => {
    if (singleExperience.category === 'HOTEL') {
      return {
        addons: selectedAddons,
        childs: childAmount,
        createdAt: getDateTime(),
        datePayment: getDateTime(),
        day: formatDateToDB(startDate),
        dayFrom: formatDateToDB(startDate),
        dayTo: formatDateToDB(endDate),
        email: email,
        experience: singleExperience.key,
        finalPrice: totalPrice + addonsPersonsPrice,
        hour: hotelHour,
        lastName: lastName,
        name: name,
        paymentStatus: statePayments.DEAL,
        persons: guestAmount,
        phone: phone,
        status: stateReservation.PENDING,
        timeZone: 'America/Santiago',
        partialPrice: singleExperience.partialPercentage
          ? singleExperience.partialPercentage + addonsPersonsPrice
          : 0,
        isPartialCharge: singleExperience.isPartialCharge
          ? singleExperience.isPartialCharge
          : false,
        payPalOrderId: orderId,
        transaction_ID: transaction_ID,
        flowOrder: '',
        clpToUsd: clpToUsd,
        discount:
          ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100,
        discountCode: detailDiscount.code ? detailDiscount.code : '',
        giftCard: giftCard
          ? {
            isGiftCard: giftCard,
            isReScheduled: false,
            giftedName: giftedName,
            giftedLastName: giftedLastName,
            giftedPhone: giftedPhone,
            giftedEmail: giftedEmail,
          }
          : { isGiftCard: giftCard },
      }
    } else {
      if (singleExperience.name === 'Motel') {
        return {
          addons: selectedAddons,
          childs: childAmount,
          createdAt: getDateTime(),
          datePayment: getDateTime(),
          day: formatDateToDB(singleDate),
          exitDay: convertDateFormat(exitDate),
          email: email,
          experience: singleExperience.key,
          finalPrice: totalPrice + addonsPersonsPrice,
          hour: time,
          exitHour: exitTime,
          lastName: lastName,
          name: name,
          paymentStatus:
            singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 &&
              hotDeal.key
              ? statePayments.DEFERRED_PAYMENT
              : statePayments.DEAL,
          persons: guestAmount,
          extraPersons: extraPersons,
          phone: phone,
          status:
            singleExperience.isPartialCharge &&
              singleExperience.partialPercentage === 0 &&
              hotDeal.key
              ? stateReservation.PAID_OUT
              : stateReservation.PENDING,
          timeZone: 'America/Santiago',
          partialPrice: singleExperience.partialPercentage
            ? singleExperience.partialPercentage + addonsPersonsPrice
            : 0,
          isPartialCharge: singleExperience.isPartialCharge
            ? singleExperience.isPartialCharge
            : false,
          payPalOrderId: orderId,
          transaction_ID: transaction_ID,
          flowOrder: '',
          clpToUsd: clpToUsd,
          discount:
            ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100,
          discountCode: detailDiscount.code ? detailDiscount.code : '',
          giftCard: giftCard
            ? {
              isGiftCard: giftCard,
              isReScheduled: false,
              giftedName: giftedName,
              giftedLastName: giftedLastName,
              giftedPhone: giftedPhone,
              giftedEmail: giftedEmail,
            }
            : { isGiftCard: giftCard },
        }
      }
      return {
        addons: selectedAddons,
        childs: childAmount,
        createdAt: getDateTime(),
        datePayment: getDateTime(),
        day: formatDateToDB(singleDate),
        email: email,
        experience: singleExperience.key,
        finalPrice: totalPrice + addonsPersonsPrice,
        hour: time,
        lastName: lastName,
        name: name,
        paymentStatus:
          singleExperience.isPartialCharge &&
            singleExperience.partialPercentage === 0 &&
            hotDeal.key
            ? statePayments.DEFERRED_PAYMENT
            : statePayments.DEAL,
        persons: guestAmount,
        phone: phone,
        status:
          singleExperience.isPartialCharge &&
            singleExperience.partialPercentage === 0 &&
            hotDeal.key
            ? stateReservation.PAID_OUT
            : stateReservation.PENDING,
        timeZone: 'America/Santiago',
        partialPrice: singleExperience.partialPercentage
          ? singleExperience.partialPercentage + addonsPersonsPrice
          : 0,
        isPartialCharge: singleExperience.isPartialCharge
          ? singleExperience.isPartialCharge
          : false,
        payPalOrderId: orderId,
        transaction_ID: transaction_ID,
        flowOrder: '',
        clpToUsd: clpToUsd,
        discount:
          ((totalPrice + addonsPersonsPrice) * detailDiscount.discount) / 100,
        discountCode: detailDiscount.code ? detailDiscount.code : '',
        giftCard: giftCard
          ? {
            isGiftCard: giftCard,
            isReScheduled: false,
            giftedName: giftedName,
            giftedLastName: giftedLastName,
            giftedPhone: giftedPhone,
            giftedEmail: giftedEmail,
          }
          : { isGiftCard: giftCard },
      }
    }
  }

  const handleReservation = async (orderId = '') => {
    /// funcion para paypal
    if (orderId !== '') {
      const reservationDetails = formatReservationDetails(orderId) //se repite en handle reservation payment
      const reservationIDS = await createReservation(
        agency.key,
        singleExperience.key,
        reservationDetails,
      )

      console.log(reservationDetails)


      // await assignResource(agency.key, singleExperience, reservationDetails) // se repite en handle reservation payment
      return [reservationIDS, reservationDetails]
    }
    ////funcion para flow
    else {
      if (
        singleExperience.isPartialCharge &&
        singleExperience.partialPercentage === 0 &&
        hotDeal.key
      ) {
        const reservationID = hotDeal.key

        return reservationID
      } else {
        const reservationDetails = formatReservationDetails(orderId)
        const reservationIDS = await createReservation(
          agency.key,
          singleExperience.key,
          reservationDetails,
        )

        return reservationIDS
      }
    }
  }
  return (
    <>
      <Button
        disabled={
          isError ||
          isExpirationCode ||
          isErrorDay ||
          !validateTerms() ||
          flowActive
        }
        variant="contained"
        style={{ width: '100%', backgroundColor: '#fff', height: '50px' }}
        onClick={() => handleReservationPayment()}
      >
        {isLoadingPayment ? (
          <CircularProgress size={20} />
        ) : (
          <>
            Pagar con{' '}
            <LazyLoadImage
              width="auto"
              height="auto"
              src={flowLogo}
              style={{ width: '80px', marginLeft: '10px' }}
            />
          </>
        )}
      </Button>
    </>
  )
}

export default FlowModule
